/**
 * Thin wrapper around window.gtag so every call site doesn't need a null
 * check. No-ops in dev / when the GA script hasn't loaded.
 *
 * Usage:  track("game_started", { game_mode: "online", innings: 3 });
 */
export function track(eventName, params = {}) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
}
